import Botao from "@/components/Botao";
import CampoTexto from "@/components/Formulario/CampoTexto";
import Badge, { BadgeVariants } from "@/components/layout/Badge";
import Grid, { GridItem } from "@/components/layout/Grid";
import HBox from "@/components/layout/HBox";
import VBox from "@/components/layout/VBox";
import { mdiArrowLeft, mdiPen, mdiTrashCan } from "@mdi/js";
import React from "react";
import Card from '../../components/layout/Card';
import CampoSeletor from "@/components/Formulario/CampoSeletor";
import { FormApiEntradas, IntegracaoApiEndpointEntrada } from "../integracao_api/FormApiEntradas";
import Tabs from "@/components/layout/Tabs";
import { FormApiSaidas, IntegracaoApiEndpointSaida } from "../integracao_api/FormApiSaidas";
import { FormApiCabecalhos, IntegracaoApiEndpointCabecalho } from "../integracao_api/FormApiCabecalhos";

type SelectedTabValues = 'entrada' | 'saida' | 'cabecalho';

export const FormIntegracaoApiCustom = ({
    value,
    onChange,
    fieldErrors,
    onEndpointSelected,
}: {
    value: any;
    onChange: any;
    fieldErrors: any;
    onEndpointSelected?: (idx: number) => void;
}) => {
    const [selectedEndpoint, setSelectedEndpoint] = React.useState<any>(null);
    const [viewMode, setViewMode] = React.useState<'list' | 'edit'>('list');

    const badgeColors: Record<string, BadgeVariants> = {
        GET: 'info',
        POST: 'success',
        PUT: 'warning',
        DELETE: 'danger',
    };

    const metodoOptions = [
        { id: 'GET', label: 'GET' },
        { id: 'POST', label: 'POST' },
        { id: 'PUT', label: 'PUT' },
        { id: 'DELETE', label: 'DELETE' },
    ];

    const endpointsOptions = value?.endpoints?.map((it: any, idx: number) => ({
        id: it.id?.toString(),
        label: (
            <Grid>
                <GridItem sm={12} md={6}>
                    {it.nome}
                </GridItem>
                <GridItem sm={12} md={5}>
                    <HBox>
                        <Badge
                            style={{ minWidth: '60px', justifyContent: 'center' }}
                            variant={badgeColors[it.metodo] || 'secondary'}
                        >
                            {it.metodo}
                        </Badge>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {it.caminho}
                        </span>
                    </HBox>
                </GridItem>
                <GridItem sm={12} md={1}>
                    <HBox style={{ justifyContent: 'flex-end' }}>
                        <Botao
                            variant="none-primary"
                            icon={mdiPen}
                            title="Editar"
                            onClick={() => { }}
                        ></Botao>
                        <Botao
                            variant="none-warning"
                            icon={mdiTrashCan}
                            title="Editar"
                            onClick={() =>
                                onChange([
                                    ...value.endpoints.filter((e: any) => e.id !== it.id),
                                ])
                            }
                        ></Botao>
                    </HBox>
                </GridItem>
            </Grid>
        ),
        error:
            fieldErrors &&
            Object.keys(fieldErrors).some(k => k.startsWith(`endpoints[${idx}].`)),
    }));

    const [endpointSelIdx, setEndpointSelIdx] = React.useState<number>(-1);
    const [endpointSearch, setEndpointSearch] = React.useState<string>('');

    const [selectedTab, setSelectedTab] =
        React.useState<SelectedTabValues>('entrada');

    const handleNewEndpoint = () => {
        const newObj = {
            metodo: 'GET',
            nome: 'Nova requisição',
            caminho: '',
            tipo_corpo: 'json',
            tipo_resposta: 'json',
        };

        onChange({ ...value, endpoints: [...(value?.endpoints ?? []), newObj] });
        setSelectedEndpoint(newObj);
        setEndpointSelIdx(value.endpoints?.length ?? -1); // endpoints ainda não foi atualizado
        onEndpointSelected?.(value.endpoints?.length ?? -1);
        setViewMode('edit');
    };

    const handleRemoveEndpoint = (idx: number) => {
        onChange({
            ...value,
            endpoints: [
                ...(value.endpoints?.filter((_: any, i: number) => i !== idx) ?? []),
            ],
        });

        setSelectedEndpoint(null);
        setEndpointSelIdx(-1);
        onEndpointSelected?.(-1);
        setViewMode('list');
    };

    const handleGoBack = React.useCallback(() => {
        console.log(selectedEndpoint, endpointSelIdx);
        //save
        onChange({
            ...value,
            endpoints: [
                ...(value.endpoints?.map((it: any, idx: number) =>
                    idx === endpointSelIdx ? selectedEndpoint : it,
                ) ?? []),
            ],
        });

        setSelectedEndpoint(null);
        setEndpointSelIdx(-1);
        onEndpointSelected?.(-1);
        setViewMode('list');
    }, [endpointSelIdx, selectedEndpoint, value, onChange, onEndpointSelected]);

    const feEntradas = fieldErrors
        ? Object.keys(fieldErrors).reduce((acc: any, k: string) => {
            const key = `endpoints[${endpointSelIdx}].api_entradas`;
            if (k.startsWith(key)) {
                acc[k.replace(key, '')] = fieldErrors[k];
            }
            return acc;
        }, {})
        : null;

    const feSaidas = fieldErrors
        ? Object.keys(fieldErrors).reduce((acc: any, k: string) => {
            const key = `endpoints[${endpointSelIdx}].api_saidas`;
            if (k.startsWith(key)) {
                acc[k.replace(key, '')] = fieldErrors[k];
            }
            return acc;
        }, {})
        : null;

    const feCabecalhos = fieldErrors
        ? Object.keys(fieldErrors).reduce((acc: any, k: string) => {
            const key = `endpoints[${endpointSelIdx}].api_cabecalhos`;
            if (k.startsWith(key)) {
                acc[k.replace(key, '')] = fieldErrors[k];
            }
            return acc;
        }, {})
        : null;

    return (
        <VBox gap="16px" style={{ minWidth: '80%' }}>
            {viewMode === 'list' && (
                <div>
                    <Grid>
                        <GridItem sm={12}>
                            <CampoTexto
                                value={value?.endereco_host ?? ''}
                                onChange={v => onChange({ ...value, endereco_host: v })}
                                label="URL servidor"
                                error={fieldErrors?.endereco_host ?? ''}
                                placeholder="Ex: https://api.example.com"
                            />
                        </GridItem>
                    </Grid>
                    <div>
                        <HBox stretch>
                            <label>Endpoints</label>
                            <Botao variant="outline-primary" onClick={handleNewEndpoint}>
                                Adicionar endpoint
                            </Botao>
                        </HBox>

                        {!value?.endpoints?.length && (
                            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                                Nenhum endpoint cadastrado.
                            </div>
                        )}
                        <Grid>
                            {value?.endpoints?.map((it: any, idx: number) => (
                                <GridItem md={3} sm={12} key={`${it.id}-${idx}`}>
                                    <div
                                        style={{ borderRadius: '16px', cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedEndpoint(it);
                                            setEndpointSelIdx(idx);
                                            onEndpointSelected?.(idx);
                                            setViewMode('edit');
                                        }}
                                    >
                                        <Card>
                                            <VBox>
                                                <div
                                                    style={{
                                                        fontWeight: 600,
                                                        textAlign: 'center',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    {it.nome}
                                                </div>
                                                <HBox>
                                                    <Badge
                                                        style={{
                                                            minWidth: '60px',
                                                            justifyContent: 'center',
                                                        }}
                                                        variant={badgeColors[it.metodo] || 'secondary'}
                                                    >
                                                        {it.metodo}
                                                    </Badge>
                                                    <span
                                                        style={{
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}
                                                    >
                                                        {it.caminho}
                                                    </span>
                                                </HBox>

                                                <HBox style={{ justifyContent: 'flex-end' }}>
                                                    <Botao
                                                        variant="none-primary"
                                                        icon={mdiPen}
                                                        title="Editar"
                                                        onClick={() => {
                                                            setSelectedEndpoint(it);
                                                            setViewMode('edit');
                                                        }}
                                                    ></Botao>
                                                    <Botao
                                                        variant="none-danger"
                                                        icon={mdiTrashCan}
                                                        title="Remover"
                                                        onClick={(e: any) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            onChange({
                                                                ...value,
                                                                endpoints: value.endpoints.filter(
                                                                    (e1: any) => e1.id !== it.id,
                                                                ),
                                                            });
                                                        }}
                                                    ></Botao>
                                                </HBox>
                                            </VBox>
                                        </Card>
                                    </div>
                                </GridItem>
                            ))}
                        </Grid>
                    </div>
                </div>
            )}
            {viewMode === 'edit' && (
                <VBox>
                    <HBox stretch>
                        <Botao
                            variant="outline-primary"
                            onClick={handleGoBack}
                            icon={mdiArrowLeft}
                        >
                            Voltar
                        </Botao>
                    </HBox>
                    <Grid>
                        <GridItem sm={12} md={6}>
                            <CampoTexto
                                value={selectedEndpoint.nome}
                                onChange={v =>
                                    setSelectedEndpoint({ ...selectedEndpoint, nome: v })
                                }
                                label="Descrição endpoint"
                                error={fieldErrors?.[`endpoints[${endpointSelIdx}].nome`]}
                            />
                        </GridItem>
                        <GridItem sm={12} md={3}>
                            <CampoSeletor
                                options={[
                                    { id: 'json', label: 'JSON' },
                                    { id: 'formData', label: 'form-data' },
                                    { id: 'urlencoded', label: 'URLEncoded' },
                                ]}
                                value={selectedEndpoint.tipo_corpo}
                                onChange={v =>
                                    setSelectedEndpoint({ ...selectedEndpoint, tipo_corpo: v })
                                }
                                label="Formato entradas"
                                error={
                                    fieldErrors?.[`endpoints[${endpointSelIdx}].tipo_corpo`] ?? ''
                                }
                            />
                        </GridItem>
                        <GridItem sm={12} md={3}>
                            <CampoSeletor
                                options={[
                                    { id: 'json', label: 'JSON' },
                                    { id: 'urlencoded', label: 'URLEncoded' },
                                ]}
                                value={selectedEndpoint.tipo_resposta}
                                onChange={v =>
                                    setSelectedEndpoint({ ...selectedEndpoint, tipo_resposta: v })
                                }
                                label="Formato saida"
                                error={
                                    fieldErrors?.[`endpoints[${endpointSelIdx}].tipo_resposta`] ??
                                    ''
                                }
                            />
                        </GridItem>
                    </Grid>

                    <Grid>
                        <GridItem md={3} sm={12}>
                            <CampoSeletor
                                noSearch={true}
                                label="Método"
                                value={selectedEndpoint.metodo}
                                onChange={v =>
                                    setSelectedEndpoint({ ...selectedEndpoint, metodo: v })
                                }
                                options={metodoOptions}
                                error={
                                    fieldErrors?.[`endpoints[${endpointSelIdx}].metodo`] ?? ''
                                }
                            />
                        </GridItem>
                        <GridItem md={9} sm={12}>
                            <CampoTexto
                                value={selectedEndpoint.caminho}
                                onChange={v =>
                                    setSelectedEndpoint({ ...selectedEndpoint, caminho: v })
                                }
                                label="Caminho"
                                placeholder="Ex: /api/v1/endpoint"
                                error={
                                    fieldErrors?.[`endpoints[${endpointSelIdx}].caminho`] ?? ''
                                }
                            />
                        </GridItem>
                    </Grid>

                    <Tabs
                        tabs={[
                            {
                                id: 'entrada',
                                label: (
                                    <HBox>
                                        <span>Entradas</span>
                                        <Badge variant="secondary">
                                            {selectedEndpoint.api_entradas?.length ?? '0'}
                                        </Badge>
                                    </HBox>
                                ),
                                content: (
                                    <FormApiEntradas
                                        fieldErrors={feEntradas}
                                        value={selectedEndpoint.api_entradas}
                                        onChange={(v: IntegracaoApiEndpointEntrada[]) =>
                                            setSelectedEndpoint((prev: any) => ({
                                                ...prev,
                                                api_entradas: v,
                                            }))
                                        }
                                    />
                                ),
                                error: feEntradas && Object.keys(feEntradas).length > 0,
                            },
                            {
                                id: 'body',
                                label: (
                                    <HBox>
                                        <span>Saídas</span>
                                        <Badge variant="secondary">
                                            {selectedEndpoint.api_saidas?.length ?? '0'}
                                        </Badge>
                                    </HBox>
                                ),
                                content: (
                                    <FormApiSaidas
                                        fieldErrors={feSaidas}
                                        value={selectedEndpoint.api_saidas}
                                        onChange={(v: IntegracaoApiEndpointSaida[]) =>
                                            setSelectedEndpoint((prev: any) => ({
                                                ...prev,
                                                api_saidas: v,
                                            }))
                                        }
                                    />
                                ),
                                error: feSaidas && Object.keys(feSaidas).length > 0,
                            },
                            {
                                id: 'headers',
                                label: (
                                    <HBox>
                                        <span>Cabeçalhos</span>
                                        <Badge variant="secondary">
                                            {selectedEndpoint.api_cabecalhos?.length ?? '0'}
                                        </Badge>
                                    </HBox>
                                ),
                                content: (
                                    <FormApiCabecalhos
                                        fieldErrors={feCabecalhos}
                                        value={selectedEndpoint.api_cabecalhos}
                                        onChange={(v: IntegracaoApiEndpointCabecalho[]) =>
                                            setSelectedEndpoint((prev: any) => ({
                                                ...prev,
                                                api_cabecalhos: v,
                                            }))
                                        }
                                    />
                                ),
                                error: feCabecalhos && Object.keys(feCabecalhos).length > 0,
                            },
                        ]}
                        size="lg"
                        selectedTab={selectedTab}
                        onTabChange={v => setSelectedTab(v as SelectedTabValues)}
                    />
                </VBox>
            )}
        </VBox>
    );
};
